import {
  FRAGMENT_CORE,
  FRAGMENT_USER_PROFILE_CORE,
  FRAGMENT_COMPANY_PROFILE_CORE,
  FRAGMENT_LOCATION_CORE,
  FRAGMENT_NEWS_LIST_CORE,
  FRAGMENT_NEWS_CORE
} from './fragments'

export const GET_TEST = `
query GetTest {
  home {
    feed {
      ...fragmentCore
    }
  }
}

${FRAGMENT_CORE}
`

export const GET_USER_PROFILE = `
query GetUserProfile {
  get_user_profile(_: true) {
    ...fragmentUserProfileCore
  }
}

${FRAGMENT_USER_PROFILE_CORE}
`

export const GET_COMPANY_PROFILE = `
query GetCompanyProfile {
  comp_list_company_profile(_: true) {
    ...fragmentCompanyProfileCore
  }
}

${FRAGMENT_COMPANY_PROFILE_CORE}
`

export const GET_SHOP_LOCATIONS = `
query GetShopLocations ($company_id: ID!){
  list_company_location(company_id: $company_id) {
    ...fragmentLocationCore
  }
}

${FRAGMENT_LOCATION_CORE}
`

export const GET_NEWS_POST_LIST = `
query GetNewsPostList (
  $company_id: ID!
  $limit: Int
  $page: Int
){
  list_news(
    company_id: $company_id
    limit: $limit
    page: $page
  ) {
    records {
      ...fragmentNewsListCore
    }
    total
  }
}

${FRAGMENT_NEWS_LIST_CORE}
`

export const GET_NEWS_POST = `
query GetNewsPost (
  $news_id: ID!
){
  get_news(
    news_id: $news_id
  ) {
    ...fragmentNewsCore
  }
}
${FRAGMENT_NEWS_CORE}
`